export const DISMISSED_RECOMMENDATIONS = 'dismissed_recommendations';
export const APPLIED_RECOMMENDATIONS = 'applied_recommendations';
export const DISMISS_LIMIT = 3;
export const SIMILAR_ORDERS_LIMIT = 3;
export const SIMILAR_ORDERS_QUERY_KEY = 'recommendations';
export const SIMILAR_ORDERS_STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes
